import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "../context/AuthContext.jsx";
import { useTheme } from "../context/ThemeContext.jsx";

const LINKS = [
  { href: "/", label: "Home" },
  { href: "/coach", label: "Your Corner" },
  { href: "/ground", label: "Your Ground" },
  { href: "/playbook", label: "The Playbook" },
];

const MENU_LINKS = [
  { href: "/record", label: "The Record" },
  { href: "/integrations", label: "Integrations" },
  { href: "/account", label: "Account" },
];

function AccountMenu({ isActive, location, showAdmin, onNavigate, onSignOut }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function handleKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  const links = showAdmin ? [...MENU_LINKS, { href: "/admin", label: "Admin" }] : MENU_LINKS;

  return (
    <div className="premium-menu" ref={menuRef}>
      <button
        type="button"
        className={`premium-menu-trigger${isActive ? " active" : ""}`}
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        Menu
      </button>
      {open && (
        <div className="premium-menu-dropdown" role="menu">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              role="menuitem"
              className={location === l.href ? "active" : ""}
              onClick={() => {
                setOpen(false);
                onNavigate?.();
              }}
            >
              {l.label}
            </Link>
          ))}
          <a
            href="#"
            role="menuitem"
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
              onSignOut();
            }}
          >
            Sign out
          </a>
        </div>
      )}
    </div>
  );
}

export default function TopBar() {
  const [location] = useLocation();
  const { logout, user } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const isMenuActive =
    MENU_LINKS.some((l) => l.href === location) || location === "/admin";

  return (
    <nav className="topbar">
      <Link href="/" className="wordmark">CONQUEST</Link>
      <div className="navlinks">
        {LINKS.map((l) => (
          <Link key={l.href} href={l.href} className={location === l.href ? "active" : ""}>
            {l.label}
          </Link>
        ))}
        <AccountMenu
          isActive={isMenuActive}
          location={location}
          showAdmin={!!user?.isAdmin}
          onSignOut={logout}
        />
        <button
          type="button"
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
        >
          {theme === "dark" ? "Light" : "Dark"}
        </button>
      </div>
    </nav>
  );
}
